var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-select",
    {
      attrs: {
        placeholder: _vm.$t(_vm.placeholder),
        multiple: _vm.multiple,
        clearable: _vm.clearable,
        size: _vm.size,
        filterable: _vm.filterable,
        loading: _vm.cateLoading,
        "no-data-text": _vm.$t("pc_biz_shoptour_no_data" /* 暂无数据 */),
        "popper-class": "max-w400",
      },
      on: {
        change: _vm.onCatalogChange,
        "visible-change": function ($event) {
          _vm.selectIsOpen = $event
        },
      },
      model: {
        value: _vm.selectCatalog,
        callback: function ($$v) {
          _vm.selectCatalog = $$v
        },
        expression: "selectCatalog",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "infinite-scroll",
              rawName: "v-infinite-scroll",
              value: _vm.loadMore,
              expression: "loadMore",
            },
          ],
          attrs: {
            "infinite-scroll-immediate": false,
            "infinite-scroll-delay": 500,
            "infinite-scroll-disabled": !_vm.selectIsOpen || _vm.finished,
          },
        },
        _vm._l(_vm.catalogList, function (item) {
          return _c(
            "yxt-tooltip",
            {
              key: item.id,
              staticClass: "item",
              attrs: {
                effect: "dark",
                "open-filter": true,
                content: item.storeCatName,
                "max-width": 300,
                placement: "top",
              },
            },
            [
              _c("yxt-option", {
                attrs: { label: item.storeCatName, value: item.id },
              }),
            ],
            1
          )
        }),
        1
      ),
      _vm.loading
        ? _c("div", { staticClass: "text-align-center" }, [
            _c("i", { staticClass: "yxt-icon-loading color-primary-6" }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }